import { render, staticRenderFns } from "./UsuariosMoodle.vue?vue&type=template&id=6134a008&"
import script from "./UsuariosMoodle.vue?vue&type=script&lang=js&"
export * from "./UsuariosMoodle.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosMoodle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports